import { Button, Modal } from "antd";
import { createPortal } from "react-dom";
import { ReactComponent as Close } from '../../../assets/images/icon/close.svg'
import { ReactComponent as Warning } from '../../../assets/images/icon/warning.svg';
import { CustomToast } from '../../cuntomToast';
import { useMyContext } from "../../../entities/context";
import { ReactComponent as Logo_S } from "../../../assets/images/icon/logo.svg"
import { ReactComponent as BarcodeV3 } from "../../../assets/images/icon/barcodeV3.svg";
import { formatPhoneNumberWithSpaces } from "../../../utils";
import { useEffect, useRef, useState } from "react";

interface IProps {
    isOpen: boolean;
    setIsOpen: Function;
    member: IMember;
    hasReservationToday?: boolean;
    isReservationError?: boolean;
}

const BarcodeVipModal = ({ isOpen, setIsOpen, member, hasReservationToday, isReservationError }: IProps) => {
    const canShowBarcode = hasReservationToday === true;
    const toastText = isReservationError
        ? '예약 정보를 불러오지 못했어요. 다시 시도해 주세요'
        : '오늘 예약이 없어 지금은 바코드를 사용할 수 없어요';
    const [isShowBarcode, setIsShowBarcode] = useState<boolean>(false);
    const [showToast, setShowToast] = useState(false);
    const [toastKey, setToastKey] = useState(0);
    const cardRef = useRef<HTMLDivElement>(null);
    const { topHeight } = useMyContext()
    const [cardInfo, setCardInfo] = useState({ top: 0, height: 0 });

    useEffect(() => {
        if (cardRef.current) {
            const rect = cardRef.current.getBoundingClientRect();
            const scrollTop = window.scrollY || window.pageYOffset;
            setCardInfo({
                top: rect.top + scrollTop,
                height: rect.height,
            });
        }
    }, [topHeight]);

    useEffect(() => {
        if (!isOpen) setShowToast(false);
    }, [isOpen]);

    const handleBarcodeClick = () => {
        if (hasReservationToday === true) {
            setIsShowBarcode(curr => !curr);
        } else {
            setToastKey(prev => prev + 1);
            setShowToast(true);
        }
    };

    return <>
        {isOpen && <Close style={{ margin: '0 var(--space16)', padding: '12px', position: 'fixed', zIndex: 1002, top: (topHeight ?? 0), left: 0, }} onClick={() => setIsOpen(false)} width={24} height={24} stroke="var(--basewhite)" />}
        <Modal
            open={isOpen}
            closeIcon={false}
            centered
            footer={null}
            mask={false}
            style={{ maxWidth: window.innerWidth > 480 ? '480px' : '100%' }}
            styles={{ wrapper: { backgroundColor: 'var(--baseblack)', pointerEvents: 'none' }, content: { padding: 0, marginInline: '40px', marginBottom: '33px', borderRadius: 0, backgroundColor: 'transparent', pointerEvents: 'auto' } }}
            onCancel={() => setIsOpen(false)}
        >
            <div ref={cardRef} style={{ paddingBottom: isShowBarcode ? '24px' : '0', paddingTop: isShowBarcode ? 0 : '24px', transition: 'padding-bottom 0.3s ease, padding-top 0.3s ease' }}>
                <div style={{ background: 'linear-gradient(129.29deg, #363636 -3.53%, #000000 93.3%)', border: '1px solid', borderRadius: 'var(--radius4)' }}>
                    <div style={{ padding: '20px', borderBottom: '1px solid var(--secondarys850, #363636)' }}>
                        <Logo_S
                            width={105}
                            height={14}
                            style={{ marginBottom: '190px' }}
                            fill={"var(--secondarys700)"}
                        />
                        <div className="display/d2 base/white">
                            {member.grade ?? ''}
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '25px 20px 32px' }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'end', gap: '4px', marginBottom: '4px' }}>
                                <div className="sub-title/st4 base/white">
                                    {member.name}
                                </div>
                                <div className="body/b2 secondary/s300">
                                    님
                                </div>
                            </div>
                            <div className="body/b2 secondary/s300">
                                {formatPhoneNumberWithSpaces(member.mobile)}
                            </div>
                        </div>
                        <Button
                            type="text"
                            icon={<BarcodeV3 width={24} height={24} fill="var(--secondarys500)" />}
                            onClick={handleBarcodeClick}
                            style={{ width: 24, height: 24, minWidth: 24, padding: 0, border: 'none', color: 'var(--secondarys500)' }}
                        />
                    </div>
                </div>
            </div>
            {canShowBarcode && <div style={{ position: 'fixed', top: (cardInfo.top + cardInfo.height), width: '78.5%', overflowX: 'hidden', paddingBlock: '8px', backgroundColor: 'var(--basewhite)', borderRadius: '4px', opacity: isShowBarcode ? 1 : 0, transition: 'opacity 0.3s ease', }}>
                <img style={{ display: 'block', width: "140%", height: 50, marginLeft: '-20%', }} src={member.barcodeImageUrl} alt="barcode" />
            </div>}
        </Modal>
        {showToast && createPortal(
            <CustomToast
                key={toastKey}
                setToast={setShowToast}
                duration={3000}
                text={<span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                    <Warning width={16} height={16} fill="var(--basewhite)" />
                    {toastText}
                </span>}
                style={{ backgroundColor: 'var(--secondarys800)', color: 'var(--basewhite)', zIndex: 1100 }}
            />,
            document.body
        )}
    </>
}

export { BarcodeVipModal };
